var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogDateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 18H2.06255C0.924774 18 0 17.0752 0 15.9375V3.56247C0 2.4247 0.924774 1.50006 2.06255 1.50006H15.9375C17.0752 1.50006 18 2.4247 18 3.56247V15.9375C18 17.0752 17.0752 18 15.9375 18ZM2.06255 2.62506C1.54578 2.62506 1.125 3.0457 1.125 3.56247V15.9375C1.125 16.4542 1.54578 16.875 2.06255 16.875H15.9375C16.4542 16.875 16.875 16.4542 16.875 15.9375V3.56247C16.875 3.0457 16.4542 2.62506 15.9375 2.62506H2.06255Z",
    className: "fill",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 7.12506H0.5625C0.251999 7.12506 0 6.87306 0 6.56256C0 6.25206 0.251999 6.00006 0.5625 6.00006H17.4375C17.748 6.00006 18 6.25206 18 6.56256C18 6.87306 17.748 7.12506 17.4375 7.12506Z",
    className: "fill",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3125 4.5C4.002 4.5 3.75 4.248 3.75 3.9375V0.5625C3.75 0.251999 4.002 0 4.3125 0C4.623 0 4.875 0.251999 4.875 0.5625V3.9375C4.875 4.248 4.623 4.5 4.3125 4.5Z",
    className: "fill",
    fill: "#3E6E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6875 4.5C13.377 4.5 13.125 4.248 13.125 3.9375V0.5625C13.125 0.251999 13.377 0 13.6875 0C13.998 0 14.25 0.251999 14.25 0.5625V3.9375C14.25 4.248 13.998 4.5 13.6875 4.5Z",
    className: "fill",
    fill: "#3E6E9C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogDateIcon);
export default __webpack_public_path__ + "static/media/blog-date-icon.c0517d645494102f0a509b2a10e6db54.svg";
export { ForwardRef as ReactComponent };